// src/components/ChooseUsSection.jsx
import React, { useState } from "react";
import { Container, Button, Collapse, Card } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import "./ChooseUsSection.css";

const ChooseUsSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const points = [
    {
      title: "Full Lifecycle Expertise",
      desc: "From business case development to deployment, testing, training, and support.",
    },
    {
      title: "Proven Delivery Record",
      desc: "Over 40+ successful projects across healthcare IT, retail, telecom, and government digitization.",
    },
    {
      title: "Dual Capability",
      desc: "Rare expertise in both digital transformation and physical infrastructure deployment.",
    },
    {
      title: "On-Time, On-Budget Results",
      desc: "Strong governance frameworks ensure accountability and transparency.",
    },
    {
      title: "Scalable & Future-Ready Solutions",
      desc: "Built to evolve with your business growth, technology, and trade needs.",
    },
  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="choose-us py-5">
      <Container>
        <div className="text-center mb-4">
          <h2 className="section-title">Why Choose Us</h2>
          <p className="section-subtitle">
            Discover what makes us the right partner for your success.
          </p>
        </div>

        <div className="toggle-list mx-auto" style={{ maxWidth: "100%" }}>
          {points.map((item, index) => (
            <div key={index} className="mb-3">
              <Button
                variant="light"
                className="toggle-btn d-flex justify-content-between align-items-center w-100"
                onClick={() => handleToggle(index)}
                aria-controls={`collapse-${index}`}
                aria-expanded={openIndex === index}
              >
                <span className="fw-bold">{item.title}</span>
                <span
                  className={`arrow-icon ${openIndex === index ? "rotate" : ""}`}
                >
                  <FaChevronDown />
                </span>
              </Button>

              <Collapse in={openIndex === index}>
                <div id={`collapse-${index}`}>
                  <Card className="p-3 mt-2 shadow-sm">
                    <p className="mb-0">{item.desc}</p>
                  </Card>
                </div>
              </Collapse>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ChooseUsSection;
